import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, number } from "prop-types";
import { selectors as depositsSelectors } from "reducers/deposits";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import { isIOS } from "react-device-detect";
import Button from "pages/_components/Button";
import DepositTabRates from "./DepositTabRates";

const DepositRates = ({ depositsRates, fetching }) => {
    const isLoading = fetching && !depositsRates.length;
    const [showInfoModal, setShowInfoModal] = useState(true);

    const tabsData = [
        {
            text: "deposit.rates.tab.1",
            textType: "I18N",
            downloadData: {
                active: true,
            },
        },
        {
            text: "deposit.rates.tab.2",
            textType: "I18N",
            downloadData: {
                active: false,
            },
        },
    ];

    const renderHeader = () => (
        <CustomProductHead
            titleId="deposits.rates.title"
            backLinkTo="/deposits/requestForm"
            className="deposit-request">
            <div className="toolbar-item view-title">
                <ViewTitle id="deposits.rates.title" />
            </div>
        </CustomProductHead>
    );
    const handleClose = () => {
        setShowInfoModal(false);
    };
    return (
        <Fragment>
            <Notification scopeToShow="deposits" />
            {!isLoading && renderHeader()}
            {/* information icon */}
            <MainContainer showLoader={isLoading}>
                <div className={isIOS ? "container pb-8" : "container pb-12"}>
                    {showInfoModal && (
                        <div className="container--alert has-close-button" role="alert">
                            <div className="alert alert-info mb-8 mt-0">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText="deposits.rates.information"
                                    titleTextType="I18N"
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                            <div className="close-button-container">
                                <Button bsStyle="link" image="cross-primary-ios.svg" onClick={handleClose} />
                            </div>
                        </div>
                    )}
                    <CustomTabs tabsData={tabsData} defaultTab={0}>
                        <DepositTabRates position={0} />
                        <DepositTabRates position={1} />
                    </CustomTabs>
                </div>
            </MainContainer>
        </Fragment>
    );
};

DepositRates.propTypes = {
    depositsRates: arrayOf({ length: number.isRequired }),
    fetching: bool,
};

DepositRates.defaultProps = {
    depositsRates: [],
    fetching: false,
};

const mapStateToProps = (state) => ({
    depositsRates: depositsSelectors.getDepositsRates(state),
    fetching: depositsSelectors.getFetching(state),
});

export default connect(mapStateToProps)(DepositRates);
